const settingsElement = document.getElementById("app.settings");

if (!settingsElement) {
  throw new Error("could not find settings element");
}

let appSettings = {}
try {
  appSettings = JSON.parse(settingsElement.innerHTML);
} catch(e) {throw new Error(`could not parse settings json: ${settingsElement.innerHTML}, ${e}`)}

export { appSettings };
